/**
 * 지연 로딩 컴포넌트들
 * 번들 크기 최적화를 위해 큰 컴포넌트들을 동적으로 로드합니다.
 */

import React, { lazy } from 'react';

// 보안 관련 컴포넌트들 (큰 번들 크기)
export const SecurityRecommendations = lazy(() => 
  import('./Security/SecurityRecommendations.jsx')
);

export const PasswordGenerator = lazy(() => 
  import('./Security/PasswordGenerator.jsx')
);

export const TwoFactorAuth = lazy(() => 
  import('./Security/TwoFactorAuth.jsx')
);

export const PasswordStrengthAnalyzer = lazy(() => 
  import('./Security/PasswordStrengthAnalyzer.jsx')
);

// 설정 관련 컴포넌트들
export const SettingsModal = lazy(() => 
  import('./Settings/SettingsModal.jsx')
);

// 공유 관련 컴포넌트들
export const PasswordShareModal = lazy(() => 
  import('./Share/PasswordShareModal.jsx')
);

export const ShareHistoryModal = lazy(() => 
  import('./Share/ShareHistoryModal.jsx')
);

// 로딩 폴백 컴포넌트
export const LoadingFallback = ({ message = '로딩 중...' }) => (
  <div className="loading-fallback">
    <div className="loading-spinner"></div>
    <p>{message}</p>
  </div>
);

// 에러 폴백 컴포넌트
export const ErrorFallback = ({ error, resetError }) => (
  <div className="error-fallback">
    <h2>컴포넌트 로딩 실패</h2>
    <p>{error.message}</p>
    <button onClick={resetError}>다시 시도</button>
  </div>
);
